class ProductDescriptionSection extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => this._init());
  }

  _init() {
    const body = this.querySelector('[data-ref="descBody"]');
    const btn = this.querySelector('[data-ref="moreBtn"]');
    if (!body || !btn) return;

    this._body = body;
    this._btn = btn;
    this._expanded = false;

    // is-collapsed already set in HTML — check if content actually overflows
    if (body.scrollHeight <= body.clientHeight + 4) {
      btn.hidden = true;
      body.classList.remove('is-collapsed');
      return;
    }

    btn.addEventListener('click', () => this._toggle());
  }

  _toggle() {
    this._expanded = !this._expanded;
    const body = this._body;

    if (this._expanded) {
      // Capture real full height so transition has a precise target
      body.style.setProperty('--pd-full-h', body.scrollHeight + 'px');
    }

    body.classList.toggle('is-collapsed', !this._expanded);
    this._btn.setAttribute('aria-expanded', String(this._expanded));

    const span = this._btn.querySelector('[data-ref="moreBtnText"]');
    if (span) {
      span.textContent = this._expanded
        ? (this._btn.dataset.labelLess || 'Less')
        : (this._btn.dataset.labelMore || 'More');
    }
  }
}

if (!customElements.get('product-description-section')) {
  customElements.define('product-description-section', ProductDescriptionSection);
}
